import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Tooltip from '@mui/material/Tooltip';
import { formatDateRange } from '../../lib/utils';
import { RefreshButton } from './CustomButtons';

const ChartTitle = ({
  title,
  showWarning,
  dateFilters,
  subtitle,
  onRefresh,
  isFetching,
  showRefreshButton = false,
}) => {
  return (
    <>
      <h5
        className="text-dark d-flex align-items-center"
        style={{ textTransform: 'capitalize' }}>
        {title}
        {showWarning && (
          <Tooltip title="Jira is not integrated">
            <WarningAmberIcon
              color="warning"
              fontSize="small"
              className="ms-2"
            />
          </Tooltip>
        )}
        {showRefreshButton && (
          <RefreshButton onRefresh={onRefresh} isFetching={isFetching} />
        )}
      </h5>
      {subtitle && (
        <p className="mt-2 mb-2" style={{ fontSize: '14px', color: '#1b3f87' }}>
          {subtitle}
        </p>
      )}
      <p className="text-muted mt-1 mb-3" style={{ fontSize: '12px' }}>
        {dateFilters && formatDateRange(dateFilters)}
      </p>
    </>
  );
};

export default ChartTitle;
